import { render } from "./ModalProtocolosFinalizar.vue?vue&type=template&id=5d574da6&scoped=true"
import script from "./ModalProtocolosFinalizar.vue?vue&type=script&lang=js"
export * from "./ModalProtocolosFinalizar.vue?vue&type=script&lang=js"

import "./ModalProtocolosFinalizar.vue?vue&type=style&index=0&id=5d574da6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d574da6"]])

export default __exports__